import { render } from "./RepairLogDetail.vue?vue&type=template&id=5b81df5d"
import script from "./RepairLogDetail.vue?vue&type=script&lang=js"
export * from "./RepairLogDetail.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__